import React, { useEffect, useState } from 'react';
import emailjs from 'emailjs-com';
import Resume from './components/Resume';
import './App.css';

function App() {

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
  });

  useEffect(() => {
    const dots = document.querySelectorAll('.dot');
    const sections = document.querySelectorAll('.section');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            dots.forEach(dot => {
              dot.classList.remove('active');
              if (dot.dataset.target === `#${id}`) {
                dot.classList.add('active');
              }
            });
          }
        });
      },
      { threshold: 0.5 } // Adjust threshold as needed
    );

    sections.forEach(section => {
      observer.observe(section);
    });
  }, []);

  // Function to handle smooth scrolling
  const handleNavClick = (event, sectionId) => {
    event.preventDefault(); // Prevent the default anchor behavior

    // Find the section element by its ID and scroll to it smoothly
    const section = document.querySelector(sectionId);
    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
  
    // Send email using EmailJS
    emailjs.send('service_tnxoe6e', 'template_qa92vtq', {
      to_name: 'Joanne Lin', // Set this to your name or the intended recipient's name
      from_name: formData.firstName + ' ' + formData.lastName, // Combine first and last name from the form
      email: formData.email, // Send the user's email
      message: formData.message // Send the user's message
    }, 'QwLFXeAUHb_varQhL')
    .then((response) => {
      console.log('Email sent successfully!', response.status, response.text);
      // Optionally, reset the form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
      });
    }, (error) => {
      console.error('Failed to send email. Error:', error);
    });
  };
  

  return (
    <div className="App">
      <nav className="navbar">
        <ul>
          <li><a href="#landing" onClick={(e) => handleNavClick(e, '#landing')}>Home</a></li>
          <li><a href="#about" onClick={(e) => handleNavClick(e, '#about')}>About</a></li>
          <li><a href="#resume" onClick={(e) => handleNavClick(e, '#resume')}>Resume</a></li>
          {/* <li><a href="#document" onClick={(e) => handleNavClick(e, '#document')}>Document</a></li>
          <li><a href="#hobbies" onClick={(e) => handleNavClick(e, '#hobbies')}>Hobbies</a></li>
          <li><a href="#gallery" onClick={(e) => handleNavClick(e, '#gallery')}>Gallery</a></li> */}
          <li><a href="#contact" onClick={(e) => handleNavClick(e, '#contact')}>Contact Me!</a></li>
        </ul>
      </nav>
      <div className="content">
        {/* Landing Section */}
        <section id="landing" className="section landing">
          <h1>I’m Joanne Lin</h1>
        </section>
        <section id="about" className="section about">
          <div className="about-container">
            <h1>Data is the key to a true understanding of a person!</h1>
            <h1>Story begins here, I’m a professional in data science and music performance. Though two fields do not meet, I believe logic and artistry are shared. In my free time, I love to take photographs, make delicious dishes, and get locally loved coffee!</h1>
            <h1>Get to know me more!</h1>
          </div>
        </section>
        <section id="resume" className="section">
          {/* Resume Section */}
          <Resume />
        </section>
        {/* <section id="document" className="section">Document Section</section>
        <section id="hobbies" className="section">Hobbies Section</section>
        <section id="gallery" className="section">Gallery Section</section> */}
        <section id="contact" className="section">
          <h1>Contact</h1>
          <div className="contact-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="name-group">
                <div className="first-name">
                  <label htmlFor="first-name">First Name </label>
                  <input type="text" id="first-name" name="firstName" value={formData.firstName} onChange={handleInputChange} placeholder="First Name" required />
                </div>
                <div className="last-name">
                  <label htmlFor="last-name">Last Name </label>
                  <input type="text" id="last-name" name="lastName" value={formData.lastName} onChange={handleInputChange} placeholder="Last Name" required />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="email">Email </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="Email" required />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleInputChange} placeholder="Your message here..." required></textarea>
              </div>
              <button type="submit" className="submit-button">Submit</button>
            </form>
          </div>
        </section>

      </div>
      <div className="dots">
        <span className="dot" data-target="#landing"></span>
        <span className="dot" data-target="#about"></span>
        <span className="dot" data-target="#resume"></span>
        {/* <span className="dot" data-target="#document"></span>
        <span className="dot" data-target="#hobbies"></span>
        <span className="dot" data-target="#gallery"></span> */}
        <span className="dot" data-target="#contact"></span>
      </div>
    </div>
  );
}

export default App;
